/**
 * Created by karan on 4/13/17.
 */

import React, { useEffect } from 'react'
import 'noty/src/noty.scss'
import 'noty/src/themes/semanticui.scss'

export default props => {
  useEffect(() => {
    if (!props.noty) return

    const handleClose = () => {
      props.closeNoty()
    }

    props.noty.on('onClose', handleClose).show()

    return () => {
      if (typeof props.noty.off === 'function') {
        props.noty.off('onClose', handleClose)
      }
    }
  }, [props.noty, props.closeNoty])

  return null
}
